import type { SEARCH_PARAMS_TYPE } from '@/constants';
import { SEARCH_PARAMS } from '@/constants';

export const setEmergencyRoomParams = (
  params: SEARCH_PARAMS_TYPE.EMERGENCY_ROOM_PARAMS,
) => {
  const newSearchParams = new URLSearchParams(location.search);

  newSearchParams.set(
    SEARCH_PARAMS.EMERGENCY_ROOM_PARAMS,
    JSON.stringify(params),
  );

  history.replaceState(null, '', `?${newSearchParams.toString()}`);

  return newSearchParams;
};
